"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatFlags = void 0;
var StatFlags;
(function (StatFlags) {
    StatFlags[StatFlags["None"] = 0] = "None";
    StatFlags[StatFlags["Anonymous"] = 1] = "Anonymous";
    StatFlags[StatFlags["OnceInSession"] = 2] = "OnceInSession";
    StatFlags[StatFlags["OnlyFirstSession"] = 4] = "OnlyFirstSession";
    StatFlags[StatFlags["OnlyForWorker"] = 8] = "OnlyForWorker";
    StatFlags[StatFlags["SendImmediately"] = 16] = "SendImmediately";
    StatFlags[StatFlags["NoCommonParams"] = 32] = "NoCommonParams";
    StatFlags[StatFlags["SendInBatch"] = 64] = "SendInBatch";
    StatFlags[StatFlags["SendOverShadowApiHost"] = 128] = "SendOverShadowApiHost";
})(StatFlags = exports.StatFlags || (exports.StatFlags = {}));
//# sourceMappingURL=StatTypes.js.map